<template>
  <div>
    <q-dialog
      :visible="isVisible"
      :title="title"
      width="800px"
      :innerScroll="false"
      :loading="loadingConfirm"
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <div class="content" v-loading="loading">
        <el-form
          ref="addForm"
          :model="addForm"
          :rules="rules"
          size="small"
          label-width="110px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="商品编码:" prop="goodsCode">
                <el-input v-model.trim="addForm.goodsCode" :disabled="this.modifyData ?  true : false" size="small" @blur="goodsCodeBlur"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品名称:" prop="goodsName">
                <span v-if="addForm.goodsName.length <= 20">{{addForm.goodsName}}</span>
                <el-tooltip class="item" effect="dark" :content="addForm.goodsName" placement="top" v-else>
                  <div class="textTips">{{addForm.goodsName}}</div>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="清仓批次:" prop="batchName">
                <el-input v-model.trim="addForm.batchName" :disabled="this.modifyData ?  true : false"  size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="清仓开始时间:" prop="clearDateStart">
                <el-date-picker
                  :disabled="this.modifyData ?  true : false"
                  v-model="addForm.clearDateStart"
                  type="date"
                  value-format="yyyyMMdd"
                  placeholder="选择日期"
                  :picker-options="pickerBeginOption"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-for="(item, index) in addForm.storeAllocationList" :key="index">
            <el-col :span="12">
              <el-form-item label="分配店铺:" :prop="'storeAllocationList.' + index + '.storeCode'" :rules="rules.storeCode">
                <el-select v-model="item.storeCode" placeholder="请选择">
                  <el-option
                    v-for="item in storeList.filter(v=>v.storeCode!=0)"
                    :key="item.storeCode"
                    :label="item.storeName"
                    :value="item.storeCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="分配量:" :prop="'storeAllocationList.' + index + '.allocationNum'" :rules="rules.allocationNum">
                <el-input v-model="item.allocationNum" size="small" @input="item.allocationNum=item.allocationNum.replace(/^0+(\d)|[^\d]+/g,'')"></el-input>
                <el-button type="text" @click="addStore" v-if="index == 0"
                  >新增店铺</el-button
                >
                <el-button type="text" @click="delStroe(index)" v-if="index > 0 || addForm.storeAllocationList.length > 1"
                  >删除店铺</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance'
export default {
  name: "addDialog",
  components: {},
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    modifyData: Object,
    storeList: Array
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return !this.modifyData ? "新增清仓商品" : '编辑清仓商品';
    },
  },
  data() {
    return {
      loading: false,
      addForm: {
        storeAllocationList: [
          {
            stroe: "",
            allocationNum: "",
          },
        ],
        goodsName: ''
      },
      rules: {
        goodsCode: [{ required: true, message: "请输入商品编码", trigger: "blur" }],
        batchName: [{ required: true, message: "请输入清仓批次", trigger: "blur" }],
        clearDateStart: [{ required: true, message: "请选择清仓开始时间", trigger: "change" }],
        storeCode: [{ required: true, message: "请选择店铺", trigger: "change" }],
        allocationNum: [{ required: true, message: "请输入分配量", trigger: "blur" }],
      },
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
      loadingConfirm: false,
      pickerBeginOption: {
          disabledDate: (time) => {
            return time.getTime() < Date.now()-1 * 24 * 60 * 60 * 1000
          }
      }
    };
  },
  methods: {
    init() {
      if (this.modifyData) {
        // this.initModifyData()
        this.loading = true
        let params = {
          fragment: [this.modifyData.dataId]
        }
        this.$q.clearanceManagement.goodsRowSreach(params).then(res => {
          console.log(res.data);
          this.addForm = res.data
          this.loading = false
        })
      }
    },
    initModifyData() {
      assignValue(this.addForm, this.modifyData);
    },
    addStore() {
      console.log(this.addForm.storeAllocationList.length);
      console.log(this.storeList.length);
      if(this.storeList.length == this.addForm.storeAllocationList.length) {
        this.$message.error('已达到最大可分配店铺数量，请核对！')
        return
      }
      this.addForm.storeAllocationList.push({
        stroe: "",
        allocationNum: "",
      });
    },
    delStroe(index) {
      this.addForm.storeAllocationList.splice(index, 1);
    },
    goodsCodeBlur() {
      this.addForm.goodsName = ''
      if(!this.addForm.goodsCode) return
      let data = JSON.parse(JSON.stringify(this.currencyForm))
      data.reportCode = 'searchGoodsInfo'
      data.param = {
        goodsCode: this.addForm.goodsCode
      }
      axios.post(`/ec-pc-api/custom/reports/data/searchGoodsInfo`,data).then(res => {
        if(res.code == 200) {
          this.$set(this.addForm,'goodsName',res.data.list[0].goodsName)
        } 
      })
    },
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      let arr  = this.addForm.storeAllocationList.map(v=>v.storeCode)
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        let params = {
          ...this.addForm,
        };
        if(Array.from(new Set(arr)).length < arr.length) {
          this.$message.error('分配店铺不能相同，请核对！')
          return
        }
        this.loadingConfirm = true
        const message = this.modifyData ? "编辑成功" : "新增成功";
        this.$q.clearanceManagement.goodsSaveOrUpdate({data: params}).then(({ data }) => {
          this.$message.success(message)
          // this.$notify.success({
          //   title: "成功",
          //   message,
          // });
          this.isVisible = false;
          this.$emit("finish");
        }).finally(() => {
          this.loadingConfirm = false
        })
      });
    },
  },
  created() {
    if(this.modifyData) {
      this.rules.allocationNum[0].required = false
    }
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.content {
  max-height: 60vh;
  overflow-y: auto;
}

.form-input {
  width: 200px;
}

.input-number {
  >>> .el-input__inner {
    text-align: left;
  }
}

>>> .el-form .el-form-item {
  margin-bottom: 22px;
}

.textTips {
  width: 200px
  height: 32px
  overflow: hidden
  white-space: nowrap;
  text-overflow: ellipsis
}
</style>